import { format as d3format } from 'd3-format';
import { inRange } from 'lodash';

const SCIENTIFIC_NOTATION_LOWER_BOUNDARY = 1e-27;
const SCIENTIFIC_NOTATION_UPPER_BOUNDARY = 1e27;

const removeTrailingZeros = (value: string) => value.replace(/(\.\d*?)0+$/, '$1');
const removeTrailingDot = (value: string) => value.replace(/\.$/, '');

export const shouldApplySIFormat = (value: number): boolean => {
  return (
    Math.abs(value) < 0.001 ||
    Math.abs(value) >= 10000 ||
    (Math.abs(value) >= 1000 && Math.round(Math.abs(value)) % 100 === 0)
  );
};

const formatSI = (value: number) => {
  if (
    !inRange(
      Math.abs(value),
      SCIENTIFIC_NOTATION_LOWER_BOUNDARY,
      SCIENTIFIC_NOTATION_UPPER_BOUNDARY,
    )
  ) {
    return d3format('.4~g')(value);
  }

  // SI notation without trailing zeros
  return d3format('.4~s')(value);
};

export const formatNumber = (value: number): string => {
  // Note: - signs are inconsistend, d3-format uses '−' while toPrecision uses '-'.
  return shouldApplySIFormat(value)
    ? formatSI(value)
    : removeTrailingDot(removeTrailingZeros(value.toPrecision(4)));
};
